import { FC } from "react";
import { ExplainerPoint } from "../atoms";

export const ExplainerPointsList: FC<{ points?: string[] }> = ({ points }) => (
  <ul className="pt-[15px] list-disc list-inside">
    {points?.map((point, index) => (
      <ExplainerPoint key={index} point={point} />
    ))}
  </ul>
);
